import { createFileRoute } from "@tanstack/react-router";
import { BonusPage } from "@/components/dashboard/bonus-page";

export const Route = createFileRoute("/bonus")({
  head: () => ({
    meta: [
      { title: "Bonus Deuxda — Deuxda Admin" },
      { name: "description", content: "Grant Bonus Deuxda to a user." },
    ],
  }),
  component: () => <BonusPage />,
});
